import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  Typography,
  Row,
  Col,
  Tooltip,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Input from 'common/components/Input';

const MetaDataForm: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="seoSection_metaData">
      <Row gutter={16}>
        <Col span={12}>
          <div className="seoSection_input">
            <Typography.Text strong>
              {t('system.keywords')}
              {' '}
            </Typography.Text>
            <Tooltip title={t('tooltip.keywords')}><QuestionCircleOutlined /></Tooltip>
            <Controller
              name="seoKeyword"
              render={({ field }) => (
                <TextArea
                  {...field}
                  className="u-mt-8"
                  value={field.value}
                  onChange={field.onChange}
                  size="large"
                  rows={2}
                  style={{ minHeight: 80 }}
                />
              )}
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="seoSection_input">
            <Typography.Text strong>
              Meta Robots
              {' '}
            </Typography.Text>
            <Tooltip title={t('tooltip.metaRobots')}><QuestionCircleOutlined /></Tooltip>
            <Controller
              name="metaRobot"
              render={({ field }) => (
                <Input
                  {...field}
                  className="u-mt-8"
                  value={field.value}
                  onChange={field.onChange}
                  size="large"
                />
              )}
            />
          </div>
        </Col>
      </Row>
      <div className="seoSection_input">
        <Typography.Text strong>
          Structured Data
          {' '}
        </Typography.Text>
        <Tooltip title={t('tooltip.structuredData')}><QuestionCircleOutlined /></Tooltip>
        <Controller
          name="structuredData"
          render={({ field }) => (
            <TextArea
              {...field}
              className="u-mt-8"
              value={field.value}
              onChange={field.onChange}
              size="large"
              rows={2}
              style={{ minHeight: 50 }}
            />
          )}
        />
        <Row gutter={16}>
          <Col span={12}>
            <div className="seoSection_input">
              <Typography.Text strong>
                Meta Viewport
                {' '}
              </Typography.Text>
              <Tooltip title={t('tooltip.metaViewport')}><QuestionCircleOutlined /></Tooltip>
              <Controller
                name="metaViewPort"
                render={({ field }) => (
                  <Input
                    {...field}
                    className="u-mt-8"
                    value={field.value}
                    onChange={field.onChange}
                    size="large"
                  />
                )}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="seoSection_input">
              <Typography.Text strong>
                CanonicalURL
                {' '}
              </Typography.Text>
              <Tooltip title={t('tooltip.canonicalURL')}><QuestionCircleOutlined /></Tooltip>
              <Controller
                name="canonicalURL"
                render={({ field }) => (
                  <Input
                    {...field}
                    className="u-mt-8"
                    value={field.value}
                    onChange={field.onChange}
                    size="large"
                  />
                )}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MetaDataForm;
